module.exports = __webpack_public_path__ + "static/img/bannerBg6.876a99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg6.png
// module id = r/v/
// module chunks = 1